import type { ReactNode } from 'react'

export interface Column<T> {
  key: string
  label: string
  numeric?: boolean
  render: (row: T) => ReactNode
}

interface Props<T> {
  /** Accessible name of the table; matches the section heading. */
  label: string
  columns: Column<T>[]
  rows: T[]
  rowKey: (row: T, index: number) => string
  emptyText: string
  rowClass?: (row: T) => string | undefined
}

export function SimpleTable<T>({ label, columns, rows, rowKey, emptyText, rowClass }: Props<T>) {
  return (
    <div className="table-wrap">
      <table aria-label={label}>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key} scope="col" className={c.numeric ? 'od-num' : undefined}>
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td colSpan={columns.length} className="od-empty-cell">
                {emptyText}
              </td>
            </tr>
          )}
          {rows.map((row, i) => (
            <tr key={rowKey(row, i)} className={rowClass?.(row)}>
              {columns.map((c) => (
                <td key={c.key} className={c.numeric ? 'od-num' : undefined}>
                  {c.render(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
